<template>
  <div>
    <v-stepper-step :complete="current > step" :step="step" :editable="!!how.from" color="#FF696F" :id="`project-step-${step}`">
      Comment avez-vous entendu parler de nous ? <span class="overline">{{how.from}}</span>
    </v-stepper-step>

    <v-stepper-content :step="step">
      <v-card min-height="200px">
        <v-row class="d-flex px-2">
          <v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 8" class="md-3">
            <v-radio-group v-model="how.from" column @change="refresh">
              <v-radio v-if="isPartner" :label="`Par ${appStyle.name}`" :value="host"></v-radio>
              <v-radio label="Sur Google" value="google"></v-radio>
              <v-radio label="Sur Facebook" value="facebook"></v-radio>
              <v-radio label="Par un partenaire" value="partenaire"></v-radio>
              <v-radio label="Par la presse" value="presse"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <div class="px-2" v-if="needMore">
          <v-text-field
          v-model="how.more"
          label="Précisez s'il vous plait"
        ></v-text-field>
        </div>
        <v-card-actions v-if="canNext">
          <v-btn outlined color="#0b755f" @click="$emit('change', how)" >Suivant</v-btn>
        </v-card-actions>
      </v-card>
    </v-stepper-content>
  </div>
</template>


<script>
import { mapGetters } from 'vuex'
export default {
  model: { prop: 'data', event: 'change' },
  props: {
    data: Object,
    step: Number,
    current: Number
  },
  methods: {
    refresh () {
      if (!this.needMore) {
        this.$emit('change', this.how)
      }
    }
  },
  computed: {
    ...mapGetters('app', ['appStyle', 'isPartner', 'host']),
    needMore: function () {
      return this.how.from === 'partenaire' || this.how.from === 'presse'
    },
    canNext: function () {
      if (!this.needMore) {
        return true
      }
      return !!this.how.more
    }
  },
  data: () => ({
    how: ''
  }),
  beforeMount () {
    this.how = this.data
  }
}
</script>